// getipwhitelistaction.js
import { partnerServices } from "../../config/axios";

export const GET_IP_WHITELIST_REQUEST = 'GET_IP_WHITELIST_REQUEST';
export const GET_IP_WHITELIST_SUCCESS = 'GET_IP_WHITELIST_SUCCESS';
export const GET_IP_WHITELIST_FAILURE = 'GET_IP_WHITELIST_FAILURE';


export const getIpWhitelistAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: GET_IP_WHITELIST_REQUEST });
    await partnerServices
        .post("getIpWhitelist", requestData, {
            headers: { AuthToken: authToken }
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: GET_IP_WHITELIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: GET_IP_WHITELIST_FAILURE, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: GET_IP_WHITELIST_FAILURE, payload: err.message });
        });
};